<template>
	<div class="info-box1">
		<div class="info-box">
			<div class="info-header u-flex u-col-center u-col-top">
				<div class="u-flex-col header-bg" style="background: #fff;">
					<div class="swiper-container u-flex-col swiper-container-info">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item,index) in imagelist1" :key="index">
								<img :src="item" alt="">
							</div>
						</div>
						<div class="swiper-button-prev" @click="toprev">
							<img src="../assets/imgs/banner1-1.png" alt="">
						</div>
						<!--左箭头。如果放置在swiper外面，需要自定义样式。-->
						<div class="swiper-button-next" @click="tonext">
							<img src="../assets/imgs/banner1-2.png" alt="">
						</div>
						<!--右箭头。如果放置在swiper外面，需要自定义样式。-->
						<!-- <div class="swiper-pagination u-flex u-col-center u-row-center">
							<span class="banner-img" :class="active == index ? 'banner-img-active' : ''" v-for="(item,index) in imagelist1" :key="index" style="margin: 0 15px;"></span>

						</div> -->
						<!--分页器。如果放置在swiper外面，需要自定义样式。-->
						
					</div>
					<div class="more u-flex u-col-center u-row-center">
						<div class="more-btn u-flex u-col-center u-row-center" @click="topictures">
							<img src="../assets/imgs/pictures.png" alt="">
							<span>{{ $t('更多图片') }}</span>
						</div>
						<div class="more-btn u-flex u-col-center u-row-center" style="margin-left: 40px" @click="tovideos">
							<img src="../assets/imgs/videos.png" alt="">
							<span>{{ $t('更多视频') }}</span>
						</div>
					</div>
				</div>
				
				<div class="header-right">
					<i class="el-icon-arrow-left" style="color: #fff;font-size: 24px;margin-bottom: 48px;" @click="leftback"></i>
					<div class="u-flex u-col-center goods-name">
						<span v-if="$locale == 'zh'">{{goods.name}}</span>
						<span v-if="$locale == 'en'">{{goods.nameEnglish}}</span>
						<span v-if="$locale == 'de'">{{goods.nameGerman}}</span>
						<!-- <span>{{$t('型号')}} {{goods.modelNumber}}</span> -->
					</div>
					<div class="goods-tips" v-if="$locale == 'zh'">{{goods.introduce}}</div>
					<div class="goods-tips" v-if="$locale == 'en'">{{goods.introduceEnglish}}</div>
					<div class="goods-tips" v-if="$locale == 'de'">{{goods.introduceGerman}}</div>
					<div class="price">
						<span style="font-size: 24px;">$</span>
						<span>{{goods.price}}</span>
					</div>
					<div class="price-down">
						{{$t('系列图片')}}
					</div>
					<div class="img-list">
						<el-image :src="a" v-for="(a,b) in imagelist2" fit="cover" :key="b"></el-image>
					</div>
					<div class="price-more" @click="handleBack">
						<div class="icon"></div>
						<span>{{$t('了解更多款式')  }}</span>
					</div>
				</div>
				
				<div class="header-right-h5">
					<div style="position: relative">
						<div class="left-icon u-flex u-row-center u-col-center" @click="toleft">
							<i class="el-icon-arrow-left"></i>
						</div>
						<div class="img-list" ref="imglist">
						
							<el-image :src="a" v-for="(a,b) in imagelist2" :preview-src-list="imagelist2" fit="cover" :key="b"></el-image>
							
						</div>
						<div class="right-icon" @click="toright">
							<i class="el-icon-arrow-right"></i>
						</div>
					</div>
					<div class="u-flex u-col-center goods-name">
						<span v-if="$locale == 'zh'">{{goods.name}}</span>
						<span v-if="$locale == 'en'">{{goods.nameEnglish}}</span>
						<span v-if="$locale == 'de'">{{goods.nameGerman}}</span>
						<span>{{$t('型号')}} {{goods.modelNumber}}</span>
					</div>
					<div class="goods-tips" v-if="$locale == 'zh'">{{goods.introduce}}</div>
					<div class="goods-tips" v-if="$locale == 'en'">{{goods.introduceEnglish}}</div>
					<div class="goods-tips" v-if="$locale == 'de'">{{goods.introduceGerman}}</div>
					<div class="price">
						<span style="font-size: 24px;">$</span>
						<span>{{goods.price}}</span>
					</div>
				</div>
			</div>
			<div class="xiangqing-box u-flex-col u-col-center u-row-center">
				<div class="xiangqing-left u-flex-col u-col-center u-row-center">
					<div class="left-title u-flex-col u-col-center u-row-center">
						<span v-if="$locale == 'zh'">{{goods.name}}</span>
						<span v-if="$locale == 'en'">{{goods.nameEnglish}}</span>
						<span>{{$t('型号')}} {{goods.modelNumber}}</span>
					</div>
					<!-- <div class="left-title">{{$t('技术规格')}}</div> -->
					<div class="left-list">
						<div class="left-item" v-if="$locale == 'zh'" v-html="goods.copyWriter"></div>
						<div class="left-item" v-if="$locale == 'en'" v-html="goods.copyWriterEnglish"></div>
						<div class="left-item" v-if="$locale == 'de'" v-html="goods.copyWriterGerman"></div>
					</div>
				</div>
				<!-- <div class="xiangqing-right">
					<img :src="$http.url + '/' + a" style="width: 100%;height: auto;" v-if="b == 0" v-for="(a,b) in goods.introducePic.split(',')" alt="">
				</div> -->
			</div>
			<!-- <div class="other-goods">
				<div class="other-title">{{$t('其他推荐')}}</div>
				<div class="swiper-container1">
					<div class="swiper-wrapper">
						<div class="swiper-slide u-flex-col" v-for="(item,index) in goodslist" :key="index" @click="toinfo(item)">
							<img :src="item.cover" alt="">
							<span class="span1" v-if="$locale == 'zh'">{{item.name}}</span>
							<span class="span1" v-if="$locale == 'en'">{{item.nameEnglish}}</span>
							<span class="span1" v-if="$locale == 'de'">{{item.nameGerman}}</span>
							<span class="span2">{{item.ccObj}}</span>
						</div>
					</div>
				</div>
				<div class="swiper-button-prev" @click="toprev1">
					<i class="el-icon-arrow-left"></i>
				</div>
				<div class="swiper-button-next" @click="tonext1">
					<i class="el-icon-arrow-right"></i>
				</div>
				
				<div class="other-list u-flex u-col-center u-row-between u-flex-wrap">
					<div class="other-item u-flex-col u-col-center" v-for="(item,index) in goodslist" :key="index" @click="toinfo(item)">
						<img :src="item.cover" alt="">
						<span class="span1" v-if="$locale == 'zh'">{{item.name}}</span>
						<span class="span1" v-if="$locale == 'en'">{{item.nameEnglish}}</span>
						<span class="span1" v-if="$locale == 'de'">{{item.nameGerman}}</span>
						<span class="span2">{{item.ccObj}}</span>
					</div>
					<div style="width: 166px;"></div>
					<div style="width: 166px;"></div>
				</div>
			</div> -->
			<!-- <div class="down-info u-flex-col u-col-center">
				<span class="span1">{{$t('巴博斯腕表精品店')}}</span>
				<span class="span2">{{$t('凭借丰富经验及专业知识，竭诚助您选购可伴随一生的时计。')}}</span>
				<video :src="indexdata.ccc" muted autoplay></video>
				<div class="h5-box u-flex-col u-col-center u-row-center">
					<span class="span4">{{$t('巴博斯腕表精品店')}}</span>
					<span class="span5">{{$t('凭借丰富经验及专业知识，竭诚助您选购可伴随一生的时计。')}}</span>
				</div>
			</div> -->
		</div>
		<!-- 店铺 -->
		<!-- <div class="shop-box">
			<div class="down-swiper">
				<div class="swiper-slide" @click="openurl(indexdata.cccLink)">
					<div class="span-box u-flex-col u-col-center u-row-center">
						<span class="span1" v-if="$locale == 'zh'">{{indexdata.cccTitle}}</span>
						<span class="span1" v-if="$locale == 'en'">{{indexdata.cccTitleEnglish}}</span>
						<span class="span1" v-if="$locale == 'de'">{{indexdata.cccTitleGerman}}</span>
						<span class="span2" v-if="$locale == 'zh'">{{indexdata.cccWa}}</span>
						<span class="span2" v-if="$locale == 'en'">{{indexdata.cccWaEnglish}}</span>
						<span class="span2" v-if="$locale == 'de'">{{indexdata.cccWaGerman}}</span>
					</div>
					<img :src="indexdata.ccc" alt="">
				</div>
			</div>
		</div> -->
	</div>
	
</template>

<script>
	import Swiper from "swiper"
	export default {
		data() {
			return {
				myswiper: null,
				myswiper1: null,
				active: 0,
				goods:{
					introducePic:''
				},
				imagelist:[],
				imagelist1: [],
				imagelist2: [],
				goodslist:[],
				indexdata:[],
				video_url: '',
				timer: null,
			}
		},
		created() {
			this.getdata()
			this.gettuijian()
			this.getindexddata()
		},
		mounted() {
			
		},
		watch:{
			$route(){
				this.getdata()
			}
		},
		methods: {
			toleft() {
			
				this.stopScroll();
				this.timer = setInterval(() => {
					this.$refs.imglist.scrollLeft -= 1500;
				this.stopScroll();

				}, 100);
			},
			toright() {
			
				this.stopScroll();
				this.timer = setInterval(() => {
					this.$refs.imglist.scrollLeft += 1500;
				this.stopScroll();

				}, 100);
			},
			stopScroll() {
				clearInterval(this.timer);
			},
			topictures() {
				this.$router.push({
					path: '/pictures',
					query: {
						pic: JSON.stringify(this.imagelist)
					}
				})
			},
			tovideos() {
				this.$router.push({
					path: '/videos',
					query: {
						url: this.goods.video 
					}
				})
			},
			leftback() {
				this.$router.go(-1)
			},
			getindexddata(){
				// this.$http.post('/api/Index/getPoster').then(res => {
				// 	this.indexdata = res.result
				// })
				this.$http.post('/api/Index/indexInfo').then(res => {
					this.indexdata = res.result
				})
			},
			/* toinfo(item){
				if(item.ccId == this.$route.query.id){
					this.$router.go()
				}else{
					this.$router.push({
						path:"/info",
						query:{
							id:item.ccId
						}
					})
				}
			}, */
			gettuijian(){
				this.$http.post('/api/Index/getShowC').then(res => {
					this.goodslist = res.result
					this.$nextTick(() => {
						this.setother()
					})
				})
			},
			getdata(){
				this.$http.post('/api/Index/getCommpdityD',{
					id:this.$route.query.id
				}).then(res => {
					this.goods = res.result
					if(this.goods.pics){
						var list = this.goods.pics.split(',')
						var list1 = this.goods.pic.split(',')
						var list2 = this.goods.introducePic.split(',')
						this.imagelist = []
						this.imagelist1 = []
						this.imagelist2 = []
						list.forEach(val => {
							this.imagelist.push(this.$http.url + '/' + val)
						})
						list1.forEach(val => {
							this.imagelist1.push(this.$http.url + '/' + val)
						})
						list2.forEach(val => {
							this.imagelist2.push(this.$http.url + '/' + val)
						})
					}
					
					if(this.$locale == 'zh'){
						document.title = this.goods.name
					}else if(this.$locale == 'en'){
						document.title = this.goods.nameEnglish
					}else{
						document.title = this.goods.nameGerman
					}
					this.$parent.settitle(document.title)
					this.$nextTick(() => {
						this.setswiper()
					})
				})
			},
			tonext1() {
				this.myswiper1.slideNext()
			},
			toprev1() {
				this.myswiper1.slidePrev()
			},
			setother() {
				this.myswiper1 = new Swiper('.swiper-container1', {
					loop: true,
					slidesPerView: 3,
					on: {
						slideChangeTransitionEnd: (e) => {
							this.active = e.realIndex
						},
					}
				});
			},
			tonext() {
				this.myswiper.slideNext()
			},
			toprev() {
				this.myswiper.slidePrev()
			},
			setswiper() {
				this.myswiper = new Swiper('.swiper-container-info', {
					loop: true,
					on: {
						slideChangeTransitionEnd: (e) => {
							this.active = e.realIndex
						},
					},
				});
			},
			handleBack(){
				this.$router.back()
			}
		}
	}
</script>

<style lang="scss">
	@import url("../../node_modules/swiper/swiper.min.css");
</style>
